<template>
  <v-bottom-navigation app v-model="selected" :color="colors.primary" dark>
    <v-btn v-for="item in navItems" :key="item.title" :to="item.to">
      <!-- <span>{{ item.title }}</span> -->
      <v-icon>{{ item.icon }}</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
import { routes } from '@/router.js';
import navItems from '@/utils/nav';
import colors from '@/utils/colors';

export default {
  name: 'app-bottom-nav',
  props: {
    value: { type: Number, default: 0 },
    isMobile: { type: Boolean, default: false },
  },
  data: () => ({
    routes,
    navItems,
    colors,
  }),
  methods: {
    close() {
      this.$emit('input', false);
    },
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>
